// extracted by mini-css-extract-plugin
export default {"mCard":"KD-z","image":"LD-z","imageNoBackground":"MD-z","imageHasCategory":"ND-z","fullWidth":"OD-z"};